export default __webpack_public_path__ + "static/media/ts-12-8.e2f889b6.svg";